module.exports = __webpack_public_path__ + "static/media/20201129_220535_427_IMG_1923.bf0c1e86.jpg";